export const VisitWholesaler = {
    path: '/visits/wholesaler',
    name: 'visits.wholesaler',
    component: () => import('@/views/Visit/VisitWholesalerPage.vue'),
    children: [
        {
            path: '/visits/wholesaler/view/:id',
            name: 'visits.wholesaler.view',
            component: () => import('@/views/Visit/Form/VisitForm.vue'),
            props: {viewAction: true, type: 'wholesaler'}
        },
        {
            path: '/visits/wholesaler/customer/view/:id',
            name: 'visits.wholesaler.customer.view',
            component: () => import('@/views/Customer/Form/CustomerForm.vue'),
            props: {viewAction: true, type: 'wholesaler'},
        },
    ]
}